<app-raport-incasari-table
  [rapoarteIncasari]="tables$ | async"
  [rapoarteIncasariLength]="total$ | async"
  [loadingDataSpinner]="loadingDataSpinner"
  (filterData)="filterSearchData($event)"
  (exportData)="exportData($event)"
  (pageSizeChanged)="changePageSize($event)"
  (pageNumberChanged)="changePageNumber($event)"
  (rapoarteIncasariTableCallback)="getTableData()"
></app-raport-incasari-table>
